
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-shipping-storage-moving-services",
      function () {
        return require("private-next-pages/college-shipping-storage-moving-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-shipping-storage-moving-services"])
      });
    }
  